import React, { FC } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useIsMobile } from '../../../../util/style-utils';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import useAuth from '../../../../hooks/useAuth';
import { useOutageLeftPanelState } from '../../providers/OutageLeftPanelStateProvider';

const useStyles = makeStyles((theme: Theme) => ({
  locationInfo: {
    fontSize: 20,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  flexRow: {
    display: 'flex',
  },
  imageContainer: {
    width: '40%',
  },
  contentCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  accountNumberName: {
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  mt5: {
    marginTop: '1rem',
  },
}));

export interface LocationInformationProps {
  accountNumber: string;
  nickName: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postal: string;
}

export const LocationInformation: FC<LocationInformationProps> = ({
  accountNumber,
  nickName,
  addressLine1,
  addressLine2,
  city,
  state,
  postal,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const isMobile = useIsMobile();
  const { isAuthenticated } = useAuth();
  const {
    panelOpen: expanded,
    multiPremiseInfo,
    singlePremiseInfo,
  } = useOutageLeftPanelState();
  const houseNumber =
    singlePremiseInfo?.houseNumber ||
    multiPremiseInfo?.selectedPremiseDetails?.houseNumber;
  return (
    <div className={`${classes.mt5} ${classes.flexRow}`}>
      {!isMobile && (
        <div className={classes.imageContainer}>
          <img
            alt="outage_Home_Icon"
            src={require('../../../../images/Report_Outage_Home_New.png')}
            width={260}
            height={200}
          />
        </div>
      )}
      <div className={classes.contentCenter}>
        <Typography className={classes.locationInfo}>
          {t('LOCATION_INFORMATION')}
        </Typography>
        {!isAuthenticated || houseNumber ? (
          <Typography className={classes.mt5}>
            {t('THE_STREET_ADDRESS_FOR_THIS_ACCOUNT')} {houseNumber}...
          </Typography>
        ) : (
          <>
            <Typography
              className={`${classes.mt5} ${classes.accountNumberName}`}
            >
              {accountNumber} - {nickName}
            </Typography>
            <Typography className={classes.locationInfo}>
              {addressLine1}
            </Typography>
            {addressLine2 && (
              <Typography className={classes.locationInfo}>
                {addressLine2}
              </Typography>
            )}
            <Typography className={classes.locationInfo}>
              {city}, {state} {postal}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};
